import { createSingletonMixin, compose } from '@descope/sdk-helpers';
import { missingAttrValidator } from './createValidateAttributesMixin/commonValidators.js';
import { createValidateAttributesMixin } from './createValidateAttributesMixin/createValidateAttributesMixin.js';

const projectIdMixin = createSingletonMixin((superclass) => {
    const BaseClass = compose(createValidateAttributesMixin({ 'project-id': missingAttrValidator }))(superclass);
    return class ProjectIdMixinClass extends BaseClass {
        get projectId() {
            return this.getAttribute('project-id');
        }
    };
});

export { projectIdMixin };
//# sourceMappingURL=projectIdMixin.js.map
